import React, {Fragment} from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Delta from '/component/base/Delta';
import FormattedNumber from '/component/base/FormattedNumber';
import Icon from '/component/base/Icon';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import {MetricsSection} from '/constant/TestIDs';

import {styles} from './DeltaListItem.style';

interface DeltaListItemProps {
  heading: string | React.ReactNode;
  headingUseCompetency: boolean;
  subheading: string | React.ReactNode;
  readonly: boolean;
  onPress: (() => void) | null;
  total: number | string | null;
  delta: number | null;
  testID: string | null;
  allowFontScaling: boolean;
  maxFontSizeMultiplier: number;
}
export const DeltaListItem: React.FC<DeltaListItemProps> = ({
  heading = null,
  headingUseCompetency = false,
  subheading = null,
  total = null,
  delta = null,
  readonly = false,
  onPress = noop,
  testID = null,
  allowFontScaling = false,
  maxFontSizeMultiplier = 2,
}) => {
  return (
    <ListItem
      testID={testID}
      readonly={readonly}
      onPress={onPress}
      // @ts-expect-error TS(2339): Property 'label' does not exist on type '{ number:... Remove this comment to see the full error message
      style={{label: styles.label, suffix: styles.number, base: styles.base}}
      label={
        <Fragment>
          <Text
            accessible={true}
            style={styles.text}
            testID={MetricsSection.metricTitle}
            allowFontScaling={allowFontScaling}
            maxFontSizeMultiplier={maxFontSizeMultiplier}
            useCompetency={headingUseCompetency}>
            {heading}
          </Text>
          <Text
            accessible={true}
            testID={MetricsSection.metricSubTitle}
            variant="caption"
            emphasis="standard"
            allowFontScaling={allowFontScaling}
            maxFontSizeMultiplier={maxFontSizeMultiplier}
            style={styles.caption}>
            {subheading}
          </Text>
        </Fragment>
      }
      suffix={
        <View style={styles.suffixContainer}>
          <View style={styles.metricsContainer} accessible={true}>
            <FormattedNumber
              testID={MetricsSection.metricValue}
              value={total}
              currencyCode="USD"
              separationStyle="thousand"
              decimalPlaces={2}
            />
            <Delta
              testID={MetricsSection.metricDelta}
              value={delta}
              style={{base: styles.delta}}
            />
          </View>
          {!readonly && <Icon name="chevron-right" style={styles.arrowIcon} />}
        </View>
      }
    />
  );
};

export default DeltaListItem;
